import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  separator: {
    display: 'block',
    backgroundColor: theme.palette.common.black,
    width: theme.spacing(0.5),
    height: theme.spacing(0.5),
    alignSelf: 'center',
    borderRadius: theme.spacing(1.25),
  },
}));

export default useStyles;
